import React from 'react';
import { Box, Modal } from '@mui/material';
import { useTranslator } from '@ianesthesie-kit/core';
import { LoadingOverlay } from '@/components/patcher';
import { useCompleteReport } from './useCompleteReport';

export const CompleteReportLoadingOverlay = () => {
  const { isLoading } = useCompleteReport();
  const translate = useTranslator();
  const label = translate(
    'doctor-dashboard.medicalDocumentType.complete_report'
  );

  return (
    <Modal open={isLoading} disableScrollLock disableEscapeKeyDown hideBackdrop>
      <Box
        role="dialog"
        aria-modal="true"
        aria-busy="true"
        aria-label={label}
        tabIndex={-1}
        sx={{ position: 'absolute', inset: 0, outline: 0 }}
      >
        <LoadingOverlay size={40} aria-label={label} />
      </Box>
    </Modal>
  );
};
